import Collapsible from 'creative-ui/uikit/Collapsible';
import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import SvgKey from 'creative-ui/uikit/svg/security/key';
import { useTranslation } from 'react-i18next';

import Flex from '@/components/Layout/Flex/Flex';
import { PasskeyCheckmarks } from '@/components/PasskeyCheckmarks/PasskeyCheckmarks';
import { Text } from '@/components/Typography/Text/Text';
import { PASSKEY_ENROLMENT_NAMESPACE } from '@/i18n/namespaces';
import { trackClick } from '@/lib/tagging';

export const PASSKEY_INFO_SEEN_KEY = 'passkey_info_seen';

interface PasskeyInfoFormProps {
  onBack: () => void;
  onLogin: () => void;
  onPasskeyLogin?: () => void;
}

export function PasskeyInfoForm({
  onBack,
  onLogin,
  onPasskeyLogin,
}: Readonly<PasskeyInfoFormProps>) {
  const { t } = useTranslation(PASSKEY_ENROLMENT_NAMESPACE);

  const handleCreatePasskey = () => {
    trackClick('mfa/passkey/info/create');
    localStorage.setItem(PASSKEY_INFO_SEEN_KEY, 'true');
    onLogin();
  };

  const handlePasskeyLogin = () => {
    localStorage.setItem(PASSKEY_INFO_SEEN_KEY, 'true');
    onPasskeyLogin?.();
  };

  return (
    <Flex direction="column" gapY={16}>
      <PasskeyCheckmarks translationNamespace={PASSKEY_ENROLMENT_NAMESPACE} />

      <Collapsible title={t('accordion.summary')} titleTag="h2" theme="blue">
        <Flex direction="column" gapY={8}>
          <div>
            <Text bold>{t('accordion.content.email')}</Text>
            <Text>{t('accordion.content.passkey')}</Text>
          </div>
          <div>
            <Text bold>{t('accordion.content.create')}</Text>
            <Text>{t('accordion.content.method')}</Text>
          </div>
        </Flex>
      </Collapsible>

      <CtaContainer stack>
        <Cta type="primary" svgLeft={SvgKey} onClick={handleCreatePasskey}>
          {t('loginAndCreate')}
        </Cta>
      </CtaContainer>

      {onPasskeyLogin && (
        <CtaContainer stack>
          <Cta type="secondary" svgLeft={SvgKey} onClick={handlePasskeyLogin}>
            {t('loginWithPasskey')}
          </Cta>
        </CtaContainer>
      )}

      <CtaContainer stack>
        <Cta type="ghost-inline" onClick={onBack}>
          {t('backToLogin')}
        </Cta>
      </CtaContainer>
    </Flex>
  );
}
